









import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import RatesComponent from '@/components/rates/RatesComponent.vue';
import { RatesModule } from '@/store/dashboard/rates/RatesModule';
import { resolveModule } from '@/store';

@Component({
  components: {
    'rates-component': RatesComponent
  }
})
export default class AccountRatesComponent extends Vue {
  private readonly ratesModule: RatesModule = resolveModule(RatesModule);

  @Prop({ required: true, type: Number }) private readonly accountId!: number;

  private loading = false;

  private async updateData(): Promise<void> {
    this.loading = true;
    await this.ratesModule.fetchForAccount(this.accountId);
    this.loading = false;
  }

  @Watch('accountId')
  private async accountIdChangeHandler(): Promise<void> {
    await this.updateData();
  }

  public async mounted(): Promise<void> {
    await this.updateData();
  }

  public async remove(rateId: number): Promise<void> {
    await this.ratesModule.remove(rateId);
    await this.ratesModule.fetchForAccount(this.accountId);
  }
}
